import type { HookProps, RhfErrorType } from './types';

import type { FieldPath, FieldValues } from 'react-hook-form';

import { RHF_ERROR_TYPES } from './constants';

export const useRhfSetError = <T extends FieldValues>({ setError }: HookProps<T>) => {
  const setMultipleLaravelFormatError = (
    errors: Partial<Record<FieldPath<T>, string[]>>,
    options?: {
      shouldFocus?: boolean;
    },
  ) => {
    Object.entries(errors).forEach(([field, errorMessages], index) => {
      const messages = errorMessages as string[] | undefined;
      if (!messages || messages.length === 0) {
        return;
      }

      // Create an object with all possible error types
      const errorTypes = RHF_ERROR_TYPES.reduce((acc, type) => {
        // Map each error message to a different error type
        const messageIndex = RHF_ERROR_TYPES.indexOf(type);
        if (messageIndex < messages.length) {
          const message = messages[messageIndex];
          if (message) {
            acc[type] = message;
          }
        }
        return acc;
      }, {} as Record<RhfErrorType, string>);

      setError(field as FieldPath<T>, {
        types: errorTypes,
      }, {
        shouldFocus: options?.shouldFocus === true && index === 0,
      });
    });
  };

  return {
    setMultipleLaravelFormatError,
  };
};
